import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'
import { PAYMENT_TICKET_API } from './consts'
import { ChangeCreditedAmountRequest } from './requests.types'
import { RevisionApplied, RevisionPreview } from './response.types'

const creditedAmountUrl = (token: string) =>
  `${API_URL}${PAYMENT_TICKET_API}/${token}/credited-amount`

export const previewCreditedAmount = (token: string, body: ChangeCreditedAmountRequest) =>
  axios.post<ApiResponse<RevisionPreview>>(`${creditedAmountUrl(token)}/preview`, body)

export const changeCreditedAmount = (token: string, body: ChangeCreditedAmountRequest) =>
  axios.post<ApiResponse<RevisionApplied>>(creditedAmountUrl(token), body)
